import { Button } from '@mui/material'
import { Auth } from 'aws-amplify'
import { VariantType, useSnackbar } from 'notistack'
import React, { useCallback, useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { getAllAvailableCategories } from 'services/category-services'
import { useCognito } from 'services/cognito-service'
import { getMyQuizzes } from 'services/quiz-services'
import { getAllAvailableSubCategories } from 'services/sub-category-services'
import { getSelf } from 'services/user-services'
import { CategoryDto, QuizDto, SubCategoryDto, UserDto, UserTokensDto } from 'types'


interface AppContextProps {
    userToken: UserTokensDto | undefined
    setUserToken(userToken: UserTokensDto | undefined): void
    user: UserDto | undefined
    setUser(user: UserDto): void
    handleMessage(message: string, type: VariantType): void
}
let initializedQuizzes = false
let initializedCategories = false
let initializedSubCategories = false

export const AppContext: React.Context<any> = React.createContext<AppContextProps | undefined>({
    userToken: undefined,
    setUserToken: () => undefined,
    user: undefined,
    setUser: () => undefined,
    handleMessage: () => undefined
})
export const useAppContext = () => {
    const k = React.useContext(AppContext)
    return k
}

export const UserManagerWrapper = (props: any) => {
    const [userToken, setUserToken] = useState<UserTokensDto>({} as UserTokensDto)
    const [user, setUser] = useState<UserDto>({} as UserDto)
    const [isPlayCards, setIsPlayCards] = useState(true)
    const location = useLocation()

    const { enqueueSnackbar, closeSnackbar } = useSnackbar();

    const handleMessage = useCallback(
      (message: string, type: VariantType) => {
        enqueueSnackbar(message, {
          anchorOrigin: { vertical: "top", horizontal: "center" },
          variant: type,
          action: (key) => (
            <Button style={{ color: "white" }} size="small" onClick={() => closeSnackbar(key)}>
              &#10006;
            </Button>
          ),
        });
      },
      [enqueueSnackbar, closeSnackbar]
    );

    useEffect(() => {
        if (location.hasOwnProperty('pathname')) {
            const list = location.pathname.split('/')
            const { [list.length - 2]: path } = list
            if (
                path === 'kort' 
                || location.pathname === "/" 
                || location.pathname === "/nyhedsbrev"
                || location.pathname === "/pris"
                ) {
                setIsPlayCards(true)

            } else {
                setIsPlayCards(false)
            }
        }
    }, [location])

    const { signedIn } = useCognito()
    useEffect(() => {
        if (signedIn) {
            const checkLogin = async () => {
                try {
                    setUser(await getSelf())
                } catch (error) {
                    //@ts-ignore
                    if (error?.response?.status !== 404) {
                        try {
                            await Auth.signOut()
                        } catch (x) {
                            // ignore
                        }
                    }
                    // else if (window.location.pathname !== '/afslutte') {
                    //     window.location.pathname = '/afslutte'
                    // }
                }
            }

            if (signedIn) {
                checkLogin().then()
            }
        }

    }, [signedIn])

    const [quizCards, setQuizCards] = useState<QuizDto[]>([])
    const [categories, setCategories] = useState<CategoryDto[]>([])
    const [subCategories, setSubCategories] = useState<SubCategoryDto[]>([])

    useEffect(() => {
        const abortController = new AbortController();
        if (signedIn && !initializedQuizzes) {
            initializedQuizzes = true;
            (async () => {
                const quizzes = await getMyQuizzes()
                setQuizCards(quizzes)
            })()
        }
        return () => abortController.abort();
    }, [signedIn])


    useEffect(() => {
        if (signedIn && !initializedCategories) {
            initializedCategories = true;
            (async () => {
                const categories = await getAllAvailableCategories()
                setCategories(categories)
            })()
        }
    }, [signedIn])

    useEffect(() => {
        if (signedIn && !initializedSubCategories) {
            initializedSubCategories = true;
            (async () => {
                const subCategories = await getAllAvailableSubCategories()
                setSubCategories(subCategories)
            })()
        }
    }, [signedIn])
    return (
        <AppContext.Provider value={{
            handleMessage,
            userToken,
            setUserToken,
            user,
            setUser,
            quizCards,
            categories,
            subCategories,
            setQuizCards,
            isPlayCards,
            setIsPlayCards
        }}>
            {props.children}
        </AppContext.Provider>
    )
}
